module.exports = __webpack_public_path__ + "img/Employee.e466ef1b.svg";